import React, { useEffect } from 'react';

interface SkipLinkProps {
  href: string;
  children: React.ReactNode;
}

export const SkipLink: React.FC<SkipLinkProps> = ({ href, children }) => {
  return (
    <a
      href={href}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary text-primary-foreground px-4 py-2 rounded-md z-50 transition-all"
      onFocus={(e) => {
        e.currentTarget.classList.remove('sr-only');
      }}
      onBlur={(e) => {
        e.currentTarget.classList.add('sr-only');
      }}
    >
      {children}
    </a>
  );
};

export const useKeyboardNavigation = () => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Add any global keyboard navigation logic here
      // For now, just handle basic accessibility patterns
      if (event.key === 'Escape') {
        // Close any open modals/dropdowns when ESC is pressed
        const activeElement = document.activeElement as HTMLElement;
        if (activeElement?.blur) {
          activeElement.blur();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};